// const url = "http://localhost:8000/api";
// const url = "http://da-test:3001/api";
const url = "https://p2p.forensic-da.com/api";
const endpoints = {
    allAlerts: url + "/alerts/list_all/",
    alerts: url + "/alerts",
    alert: url + "/alerts/",
    tasksTab: url + "/tasks/",
    tasks: (alertId) =>{
        return url + "/alerts/"+ alertId + "/tasks/";
    },
    task: url + "/tasks/",
    tasksSub: (taskktId) => {
        return url +  "/tasks/" + taskktId + "/" + "respond/";
    },
    log: (alertId) => {
        return "/alerts/"+ alertId + "/logs";
    },
    transaction: url + "/transactions",
    transactionPagination: (serverPage) => {
        return url + "/transactions" + "?page="+serverPage
    },
    entities: (type) =>{
        return url + "/entities?type=" + type;
    },
    entity:(entityID) => {
        return url + "/entities/" + entityID;
    },
    entity_transaction: (entityId) => {
        return "/entities/"+entityId+"/transactions";
    },
    auth: url + "/auth",
    menu: url + "/menus",
    attachment: url + "/upload",
    assigneeList: url + "/users/list_of_assignee/",
    clusteranalysis: url + "/vendor_cluster_analysis/",
    clusterkrywords: url + "/vendor_cluster_keywords/",

};

export default endpoints;



// WEBPACK FOOTER //
// ./src/config/config.js